import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Typography } from 'antd';
import userCard from 'assets/images/user_card.webp';

const { Text } = Typography;

function UserInfoCard({ name, mcc, accountNumber, email, bankName, city, phone, mid, smid }) {
  return (
    <div
      style={{
        backgroundImage: `url(${userCard})`,
        backgroundSize: 'cover',
        boxShadow: '0px 2px 6px #0000001A',
        borderRadius: '13px',
        padding: '14px',
        paddingLeft: '6%',
        paddingRight: '6%',
        height: '100%',
        color: 'white'
      }}
    >
      {/* Header */}
      <div style={{ marginBottom: 20 }}>
        <Text
          style={{
            fontSize: 20,
            fontWeight: 600,
            color: '#FFFFFF'
          }}
        >
          {name}{' '}
          <span style={{ fontWeight: 400, opacity: 0.9, color: '#FFFFFF' }}>
            (MID: {mid || 'N/A'}){smid && <span>(SMID: {smid || 'N/A'})</span>}
          </span>
        </Text>
      </div>

      {/* Body */}
      <Row gutter={[0, 12]}>
        <Col span={12}>
          <Text style={{ fontWeight: 500, color: '#FFFFFF' }}>MCC:</Text>
          <br />
          <Text style={{ color: '#FFFFFF' }}>{mcc}</Text>
        </Col>
        <Col span={12}>
          <Text style={{ fontWeight: 500, color: '#FFFFFF' }}>Email:</Text>
          <br />
          <Text style={{ color: '#FFFFFF' }}>{email}</Text>
        </Col>

        <Col span={12}>
          <Text style={{ fontWeight: 500, color: '#FFFFFF' }}>Phone no:</Text>
          <br />
          <Text style={{ color: '#FFFFFF' }}>{phone}</Text>
        </Col>
        <Col span={12}>
          <Text style={{ fontWeight: 500, color: '#FFFFFF' }}>City:</Text>
          <br />
          <Text style={{ color: '#FFFFFF' }}>{city}</Text>
        </Col>

        <Col span={12}>
          <Text style={{ fontWeight: 500, color: '#FFFFFF' }}>Settlement A/c Number:</Text>
          <br />
          <Text style={{ color: '#FFFFFF' }}>{accountNumber}</Text>
        </Col>
        <Col span={12}>
          <Text style={{ fontWeight: 500, color: '#FFFFFF' }}>Settlement Bank Name:</Text>
          <br />
          <Text style={{ color: '#FFFFFF' }}>{bankName}</Text>
        </Col>
      </Row>
    </div>
  );
}

UserInfoCard.propTypes = {
  name: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  bankName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  mcc: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  accountNumber: PropTypes.string.isRequired,
  mid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  smid: PropTypes.oneOfType([PropTypes.string])
};

UserInfoCard.defaultProps = {
  mid: null,
  smid: null
};

export default UserInfoCard;
